import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { CallService } from '../../../services/call.service';

@Component({
  selector: 'app-incoming-call-dialog',
  templateUrl: './incoming-call-dialog.component.html',
  styleUrls: ['./incoming-call-dialog.component.scss']
})
export class IncomingCallDialogComponent implements OnInit {
  @Input() callId: string = '';
  @Input() callerName: string = '';
  @Input() callerRole: string = '';

  private autoCloseTimer: any;

  constructor(
    private ref: NbDialogRef<IncomingCallDialogComponent>,
    private callService: CallService
  ) {}

  ngOnInit(): void {
    this.autoCloseTimer = setTimeout(() => {
      this.ref.close();
    }, 30000);
  }

  accept(): void {
    clearTimeout(this.autoCloseTimer);
    this.callService.acceptCall(this.callId);
    this.ref.close();
  }

  reject(): void {
    clearTimeout(this.autoCloseTimer);
    this.callService.rejectCall(this.callId, 'Rejected');
    this.ref.close();
  }
}
